import React, { Component } from 'react';

import ExpertCatReport from "../src/components/Reports/ExpertCatReport"
 

 
class CatReport extends Component {
 
  render() {
    
    return (
      <ExpertCatReport />
    );
  }
}
 
export default CatReport;